import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Actions, Link } from 'ui-kit/actions'
import { CONNECTOR_DOCS_LINK } from 'routes/constants'
import { ConnectorFramework } from 'routes/components/Features/ConnectorFramework'
import classes from './LandingFramework.module.scss'

export const LandingFramework = () => {
  return (
    <Block as={'section'} divider={'full'} className={classes.section}>
      <hgroup className={classes.heading}>
        <Heading as={'h2'} size={'xl'} balance center className={classes.title}>
          Scale deep native integrations with Universal Connectors
        </Heading>
        <Text size={'lg'} balance center className={classes.subtitle}>
          Authenticate, access data and metadata, subscribe to events, and work
          with business objects in a consistent way across all integrations.
        </Text>
      </hgroup>

      <ConnectorFramework />

      <Actions className={classes.actions}>
        <Link
          href={CONNECTOR_DOCS_LINK}
          type={'secondary'}
          target={'_blank'}
          asPageButton
          className={classes.link}
        >
          Learn more about Universal Connectors
        </Link>
      </Actions>
    </Block>
  )
}
